import React, { useState, useEffect } from 'react';
import { db } from '../common/Firestore';
import * as COLLECTION from '../common/constant/collections'
import { collection, getDocs, setDoc, doc, addDoc, deleteDoc } from "firebase/firestore";
import dayjs from 'dayjs';

export const useSchool = () => {
    const [schools, setSchools] = useState(null);

    useEffect(() => {
        getListschool()
    }, [])

    const getListschool = async () => {
        let sc = []
        const schoolData = await getDocs(collection(db, COLLECTION.SCHOOL));
        if (schoolData) {
            schoolData.forEach((school) => {
                if (school.exists) {
                    const schoolData = school.data();
                    sc.push({ key: school.id, ...schoolData })
                }
            })
        }
        setSchools(sc)
    }

    const updateSchool = async (school) => {
        if (school) {
            try {
                if (school.key || school.id) {
                    const res = await setDoc(doc(db, COLLECTION.SCHOOL, school.key ? school.key : school.id), school)
                    if (!res) {
                        let finalSchool = (schools && Array.isArray(schools)) ? [...schools] : []
                        let oldConfigIndex = finalSchool.findIndex(t => t.key === school.key)
                        if (oldConfigIndex != -1)
                            finalSchool[oldConfigIndex] = school;
                        else finalSchool.push(school)
                        setSchools(finalSchool)
                        return { error: false, data: finalSchool, message: "Success" }
                    } else {
                        console.log("RESPONSE: ", res)
                        return { error: true, data: res, message: `Cannot update school: ${res.message} "` };
                    }
                } else {
                    const res = await addDoc(collection(db, COLLECTION.SCHOOL), school)
                    if (res) {
                        console.log("RESPONSE: ", res)
                        let finalSchool = (schools && Array.isArray(schools)) ? [...schools] : []
                        finalSchool.push({ key: res.key, ...school })
                        setSchools(finalSchool)
                        return finalSchool
                    }
                }
            } catch (error) {
                console.error("Cannot save school: ", error)
                return { error: true, message: error }
            }
        } else return { error: true, message: "Không thể cập nhật với thông tin để trống!" }
    }

    const addNewSchool = async (newSchool) => {
        if (newSchool) {
            try {
                const res = await addDoc(collection(db, COLLECTION.SCHOOL), newSchool)
                if (res) {
                    let finalSchool = (schools && Array.isArray(schools)) ? [...schools] : []
                    finalSchool.push(newSchool)
                    setSchools(finalSchool)
                    return finalSchool
                }

            } catch (error) {
                console.error("Cannot add new school: ", error)
            }
        } else return
    }

    const deleteSchool = async (school) => {
        if (school && school.id) {
            try {
                const res = await deleteDoc(doc(db, COLLECTION.SCHOOL, school.id))
                // console.log("DELETE RESONSE: ", res)

            } catch (error) {
                console.error("Không thể xoá School: ", error)
                return {
                    success: false,
                    code: 1,
                    message: `Có lỗi xảy ra: ${error}`
                }
            }
            await getListschool()
        } else {
            return {
                success: false,
                code: 2,
                message: "Danh sách người dùng phải là một mảng giá trị"
            }
        }
        return { success: true, code: 0, message: "Xóa trường học thành công" }
    }

    return { schools, updateSchool, addNewSchool, deleteSchool };
}